import { render, staticRenderFns } from "./painSpot_edit.vue?vue&type=template&id=769e00f4&scoped=true"
import script from "./painSpot_edit.vue?vue&type=script&lang=js"
export * from "./painSpot_edit.vue?vue&type=script&lang=js"
import style0 from "./painSpot_edit.vue?vue&type=style&index=0&id=769e00f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "769e00f4",
  null
  
)

export default component.exports